import "./styles.scss";

import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import ContactForm from "./components/Form";
// import Calendly from "./components/Calendly";
import DetailsCard from "components/DetailsCard";
import AnimatedGradient from "components/AnimatedGradient";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";
import gradient_props from "libs/gradient_props";

const mainClass = "contact-content";

const ContactContent = ({ setFormSent }) => {
  const { t } = useTranslation();
  const { max, min } = useResponsive();

  const { theme } = useApp();

  const { time, seed, colors } = gradient_props.blue;

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__column`}>
        <div className={`${mainClass}__info`}>
          <div>
            <h3>{t("Contact us in a convenient way")}</h3>
            <p>
              {t(
                "Phone call, online meeting, or contact form — all these methods are at your disposal. Regardless of the option you choose, you'll receive a quick and professional response to your questions.",
              )}
            </p>
          </div>
          <div className={`${mainClass}__info-background`}>
            {!max.sm && (
              <AnimatedGradient
                id="info-gradient"
                time={time}
                seed={seed}
                colors={colors[theme]}
              />
            )}
          </div>
        </div>
      </div>

      {/* <div className={`${mainClass}__column`}>
        <DetailsCard title={t("Schedule a call / online meeting")}>
          <div className={`${mainClass}__widget`}>
            <Calendly />
          </div>
        </DetailsCard>
      </div> */}

      <div className={`${mainClass}__column`}>
        <DetailsCard title={min.sm ? t("Contact form") : undefined}>
          <ContactForm setFormSent={setFormSent} />
        </DetailsCard>
      </div>

      {max.sm && (
        <div className={`${mainClass}__scroll`}>
          <ScrollTopMobile />
        </div>
      )}
    </div>
  );
};

export default ContactContent;
